// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__Biw14","right":"Footer_right__3toNl","buttons":"Footer_buttons__3ojNT"};